import React from 'react';
import { useIntl } from 'react-intl';
import { Container, Label } from 'semantic-ui-react';
import HoverActionButtons from '@/components/buttons/HoverActionButtons';
import { formatList } from '@/utils/resultsHelper';
import { safeFormArray } from '../state/state';

const FormStringsDescriptionWrapper = ({
  canEdit,
  options = [],
  showEdit,
  text,
}) => {
  const intl = useIntl();
  const items = safeFormArray(text);

  return (
    <HoverActionButtons
      canEdit={canEdit}
      showEdit={showEdit}
      editCopyMods="label-group"
      value={items.length > 0 ? text : null}
    >
      {items.length > 0 && (
        <Label.Group className="aridhia-form-strings-description aridhia-h4 aridhia-tag">
          {items.map((i) => (<Label key={i} content={formatList(i, options)} />))}
        </Label.Group>
      )}
      {items.length === 0 && (
        <Container
          className="form-placeholder no-content"
          {...canEdit && { content: intl.formatMessage({ id: 'click.to.edit' }) }}
        />
      )}
    </HoverActionButtons>
  );
};

export default FormStringsDescriptionWrapper;
